<template>
  <div>
    <checklist-input
      :editable="editable"
      :name="`checklist-item-${model.id}`"
      :label="description"
      :model-value="itemValue"
      @update:modelValue="handleModelItemChanged"
    ></checklist-input>

    <div v-if="model?.checklist_subitems?.length > 0 && itemValue === 'NC'">
      <div
        class="form-group checklist d-flex align-items-center m-0"
        v-for="subitem in model.checklist_subitems"
        :key="subitem.id"
      >
        <checklist-model-subitem
          :editable="editable"
          :model="model"
          :subitem="subitem"
          :description="subitem.name"
          @update:subitemValue="
            ($event) => handleSubitemChanged(model.id, subitem.id, $event)
          "
        >
        </checklist-model-subitem>
      </div>
    </div>
  </div>
</template>

<script>
  import ChecklistInput from './ChecklistInput.vue'
  import ChecklistModelSubitem from './ChecklistModelSubitem.vue'

  export default {
    components: {
      ChecklistInput,
      ChecklistModelSubitem,
    },
    props: {
      editable: {
        type: Boolean,
        required: false,
        default: true,
      },
      model: {
        type: Object,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      itemValue: {
        type: String,
        required: false,
        default: '',
      },
    },
    emits: ['update:itemValue', 'update:subitemValue'],
    data() {
      return {
        //
      }
    },
    methods: {
      handleModelItemChanged($event) {
        this.$emit('update:itemValue', $event)
      },
      handleSubitemChanged(modelId, subitemId, value) {
        this.$emit('update:subitemValue', {
          modelId,
          subitemId,
          value,
        })
      },
    },
  }
</script>
